import Logo from '@/assets/images/3p-logo.png';

type Props = {
	onLeave?: () => void;
};

export default function MeetCameraHeader({ onLeave }: Props) {
	return (
		<div className={'meet-camera-header'}>
			<div className={'meet-camera-header-logo'}>
				<a href="/">
					<img
						src={Logo}
						alt="Dopin Hafıza 3P"
					/>
				</a>
			</div>
			<div className={'meet-camera-header-action-buttons'}>
				<div
					className="meet-camera-header-action-buttons-end-call"
					onClick={onLeave}>
					Testi Sonlandır
				</div>
			</div>
		</div>
	);
}
